var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRatingIndicator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 62,
    viewBox: "0 0 32 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.32 27.31C25.03 29.6 17 35.8115 17 43.0015V46.0042C17 49.0541 19.54 51.06 20.24 51.76C21.33 52.84 22 54.34 22 56C22 59.31 19.32 62 16 62C12.68 62 10 59.31 10 56C10 54.34 10.67 52.84 11.75 51.76C12.46 51.06 15 49.0541 15 46.0042C15 42.9542 15 43.0015 15 43.0015C15 35.8115 6.97 29.6 4.68 27.31C1.79 24.42 0 20.42 0 16C0 7.16 7.15 0.01 16 0C24.85 0.01 32 7.16 32 16C32 20.42 30.21 24.42 27.32 27.31Z",
    fill: "#005A9E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingIndicator);
export default __webpack_public_path__ + "static/media/rating-indicator.327906a7.svg";
export { ForwardRef as ReactComponent };